export class AppChatMsgGetRequest {
    user: string;
    s_chat: number;
    s_ins: number;
    chat_user: number;
    chat_tp: number;
    msg_from_start_ind: number;

    constructor(user: string, s_chat: number, s_ins: number, chat_user: number, chat_tp: number, msg_from_start_ind: number){
        this.user = user;
        this.s_ins = s_ins;
        this.chat_user = chat_user;
        this.chat_tp = chat_tp;
        this.msg_from_start_ind = msg_from_start_ind;
        this.s_chat = s_chat;
    }
}